'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const hooks_useClickOutside = require('../../../hooks/useClickOutside.cjs.js');
const components_display_Avatar_Avatar = require('../../display/Avatar/Avatar.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
require('../../../utils/heading-level-context/HeadingLevelContext.cjs.js');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Tag_Tag = require('../../display/Tag/Tag.cjs.js');
const components_forms_Menu_Menu = require('../../forms/Menu/Menu.cjs.js');
const components_forms_Menu_MenuItem = require('../../forms/Menu/MenuItem.cjs.js');
const components_navigation_LegacyButton_Button = require('../../navigation/LegacyButton/Button.cjs.js');
const components_navigation_Link_Link = require('../../navigation/Link/Link.cjs.js');
const components_patterns_ServiceIcons_ServiceIcons = require('../../patterns/ServiceIcons/ServiceIcons.cjs.js');
const components_marketing_ZapCard_useResizeObserver = require('./useResizeObserver.cjs.js');
const components_marketing_ZapCard_utils_darkenColor = require('./utils/darkenColor.cjs.js');

const root = "_root_13yrc_2";
const inner = "_inner_13yrc_10";
const layout = "_layout_13yrc_115";
const titleArea = "_title-area_13yrc_144";
const title = "_title_13yrc_144";
const link = "_link_13yrc_219";
const ctaArea = "_cta-area_13yrc_236";
const ctaLink = "_cta-link_13yrc_260";
const ctaIcon = "_cta-icon_13yrc_292";
const menuArea = "_menu-area_13yrc_296";
const menuToggle = "_menu-toggle_13yrc_328";
const menu = "_menu_13yrc_296";
const menuInner = "_menu-inner_13yrc_360";
const menuItemInner = "_menu-item-inner_13yrc_366";
const menuItemText = "_menu-item-text_13yrc_374";
const labelArea = "_label-area_13yrc_380";
const servicesArea = "_services-area_13yrc_404";
const metaInfoArea = "_meta-info-area_13yrc_412";
const authorArea = "_author-area_13yrc_440";
const authorContent = "_author-content_13yrc_486";
const authorByLine = "_author-by-line_13yrc_500";
const authorName = "_author-name_13yrc_513";
const summary = "_summary_13yrc_519";
const detailsContent = "_details-content_13yrc_531";
const detailsHref = "_details-href_13yrc_538";
const styles = {
	root: root,
	inner: inner,
	layout: layout,
	titleArea: titleArea,
	title: title,
	link: link,
	ctaArea: ctaArea,
	ctaLink: ctaLink,
	ctaIcon: ctaIcon,
	menuArea: menuArea,
	menuToggle: menuToggle,
	menu: menu,
	menuInner: menuInner,
	menuItemInner: menuItemInner,
	menuItemText: menuItemText,
	labelArea: labelArea,
	servicesArea: servicesArea,
	metaInfoArea: metaInfoArea,
	authorArea: authorArea,
	authorContent: authorContent,
	authorByLine: authorByLine,
	authorName: authorName,
	summary: summary,
	detailsContent: detailsContent,
	detailsHref: detailsHref
};

const DEFAULT_COLOR = "#fffdf9";
const isDefaultColor = (color) => {
  return color === DEFAULT_COLOR;
};
const getDefaultComputedColors = () => ({
  backgroundColor: DEFAULT_COLOR,
  backgroundColorDark: "rgb(0, 0, 0, 0.25)"
});
const getComputedColors = (color) => {
  if (isDefaultColor(color) || !color) {
    return getDefaultComputedColors();
  }
  try {
    return {
      backgroundColor: components_marketing_ZapCard_utils_darkenColor.darkenColor(color, { contrast: 3 }),
      backgroundColorDark: components_marketing_ZapCard_utils_darkenColor.darkenColor(color, {
        contrast: 4.5,
        minimumLightnessDistance: 10
      })
    };
  } catch (err) {
    return getDefaultComputedColors();
  }
};
const hasMenu = (menuItems) => {
  return (menuItems || []).length > 0;
};
const CARD_MAX_WIDTH = 375;
const SMALL_LINE_MAX_WIDTH = 770;
const MEDIUM_LINE_MAX_WIDTH = 615;
const isCardLayout = (computedState) => {
  return computedState.layout === "card";
};
const isLineLayout = (computedState) => {
  return computedState.layout === "line";
};
const isMegaLayout = (computedState) => {
  return computedState.layout === "mega";
};
const isCardLayoutWidth = (computedState) => {
  return computedState.width <= CARD_MAX_WIDTH;
};
const isWideLayoutWidth = (computedState) => computedState.width > SMALL_LINE_MAX_WIDTH;
const isMediumLineLayoutWidth = (computedState) => {
  return computedState.width > CARD_MAX_WIDTH && computedState.width <= MEDIUM_LINE_MAX_WIDTH;
};
const isLargeLineLayoutWidth = (computedState) => {
  return computedState.width > MEDIUM_LINE_MAX_WIDTH;
};
const getWidth = (computedState) => {
  let width = "card";
  if (isMediumLineLayoutWidth(computedState))
    width = "medium-line";
  else if (isLargeLineLayoutWidth(computedState))
    width = "large-line";
  else if (isWideLayoutWidth(computedState))
    width = "wide";
  else if (isCardLayoutWidth(computedState))
    width = "card";
  return width;
};
const getLayout = (computedState) => {
  return computedState.layout;
};
const computeLineLayoutGrid = (computedState, props) => {
  if (isLargeLineLayoutWidth(computedState)) {
    return {
      "--_zds-line-layout-columns": "max-content max-content 1fr max-content max-content max-content",
      "--_zds-line-layout-areas": `
      'services title title title label cta menu'
        '.        ${props.authorName ? "author" : "meta"}  meta  meta   meta     .   .'`
    };
  }
  return {
    "--_zds-line-layout-columns": "max-content 1fr max-content",
    "--_zds-line-layout-areas": '"services title cta"'
  };
};
const isCardOrMegaLayout = (computedState) => {
  return isCardLayout(computedState) || isMegaLayout(computedState);
};
const shouldBeColored = (computedState) => {
  return isCardOrMegaLayout(computedState) && !isDefaultColor(computedState.backgroundColor);
};
const ZapCardCTA = (props) => {
  const { computedState, ariaHidden, href, isLink, target } = props;
  const ctaBody = isLink ? jsxRuntime.jsx(React.Fragment, { children: jsxRuntime.jsxs(components_navigation_Link_Link.Link, { className: styles.ctaLink, href, target, tabIndex: ariaHidden ? -1 : void 0, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), children: ["Try it", jsxRuntime.jsx("span", { className: styles.ctaIcon, "data-layout": getLayout(computedState), "data-zds": true, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { isBlock: true, name: "arrowBigRight", size: 24 }) })] }) }) : jsxRuntime.jsx(components_navigation_LegacyButton_Button.LegacyButton, { href: props.href, target, tabIndex: ariaHidden ? -1 : void 0, size: "medium", children: "Try it" });
  return (
    // Add `aria-hidden` to avoid redundant CTAs if it's already handled by `link`.
    // Also add `tabIndex={-1}` to the `Link` or `Button` since nodes with `aria-hidden` on them
    // shouldn't contain interactive elements.
    jsxRuntime.jsx("div", { "aria-hidden": ariaHidden, className: styles.ctaArea, "data-layout": getLayout(computedState), "data-overlay-link": props.shouldOverlayLink, "data-zds": true, children: ctaBody })
  );
};
const defaultRenderAuthor = (props, computedState) => {
  if (!props.authorName) {
    return null;
  }
  const [first, ...rest] = props.authorName.split(/\s+/);
  const last = rest.pop();
  const lastInitial = last ? `${last[0]}.` : "";
  const name = `${first} ${lastInitial}`.trim();
  const author = jsxRuntime.jsxs("p", { "aria-hidden": true, className: styles.authorByLine, "data-layout": getLayout(computedState), "data-zds": true, children: ["by", " ", jsxRuntime.jsx("span", { className: styles.authorName, "data-zds": true, children: name })] });
  return jsxRuntime.jsxs("div", { "aria-label": `by ${props.authorName}`, className: styles.authorContent, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), "data-zds": true, children: [jsxRuntime.jsx(components_display_Avatar_Avatar.Avatar, { "aria-hidden": true, isBlock: true, name: props.authorName, size: "small", url: props.authorAvatarUrl }), jsxRuntime.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: props.authorName, position: "southwest", shouldCorrectPosition: false, children: () => author })] });
};
const defaultRenderLabel = (props, computedState) => {
  const color = shouldBeColored(computedState) ? "inverted" : "default";
  return props.label && jsxRuntime.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: props.labelTooltip, position: "southeast", shouldCorrectPosition: false, children: () => jsxRuntime.jsx(components_display_Tag_Tag.Tag, { variant: color, children: props.label }) });
};
const defaultRenderMenu = (props, computedState, { closeMenu }) => {
  var _a, _b, _c;
  const hasDetailsMenuItem = props.detailsLink && isLineLayout(computedState) && isMediumLineLayoutWidth(computedState);
  if (!hasDetailsMenuItem && !hasMenu(props.menuItems)) {
    return null;
  }
  const renderMenuItem = (item) => {
    const onClick = (e) => {
      item.onClick && item.onClick(e, item);
      closeMenu();
    };
    const icon = item.icon && jsxRuntime.jsx(components_display_Icon_Icon.Icon, { name: item.icon, size: 24 });
    return jsxRuntime.jsx(components_forms_Menu_MenuItem.MenuItem, { href: item.href, onClick, rel: item.rel, children: jsxRuntime.jsxs("span", { className: styles.menuItemInner, "data-zds": true, children: [icon, jsxRuntime.jsx("span", { className: styles.menuItemText, "data-zds": true, children: item.text })] }) }, item.text);
  };
  const items = ((_a = props.menuItems) !== null && _a !== void 0 ? _a : []).map(renderMenuItem);
  return jsxRuntime.jsx("div", { className: styles.menu, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), "data-zds": true, children: jsxRuntime.jsx(components_forms_Menu_Menu.Menu, { "aria-label": "Zap options", children: jsxRuntime.jsxs("div", { className: styles.menuInner, "data-zds": true, children: [items, hasDetailsMenuItem && renderMenuItem({
    text: "See Zap details",
    icon: "miscList",
    href: (_b = props.detailsLink) === null || _b === void 0 ? void 0 : _b.href,
    rel: (_c = props.detailsLink) === null || _c === void 0 ? void 0 : _c.rel,
    onClick: (e) => {
      var _a2;
      return (_a2 = props.detailsLink) === null || _a2 === void 0 ? void 0 : _a2.onClick(e, computedState);
    }
  })] }) }) });
};
const defaultRenderMetaInfo = (props, computedState) => {
  if (props.metaInfo) {
    return props.metaInfo;
  }
  const truncatedServices = computedState.uniqueServices.slice(0, 3);
  const countDiff = computedState.uniqueServices.length - truncatedServices.length;
  return [...truncatedServices, countDiff > 0 && `${countDiff} more`].filter(Boolean).join(" + ");
};
const ZapCard = ({ authorName, authorAvatarUrl, canClickOutsideToClose, children, color = DEFAULT_COLOR, detailsLink, href, hrefTarget = "_self", label, labelTooltip, layout = "auto", menuItems = [], metaInfo, onClick, renderAuthor, renderLabel, renderMenu, renderMetaInfo, services, shouldOverlayLink = true, title }) => {
  const colorValue = color || DEFAULT_COLOR;
  const allProps = {
    authorName,
    authorAvatarUrl,
    canClickOutsideToClose,
    children,
    color,
    detailsLink,
    href,
    hrefTarget,
    label,
    labelTooltip,
    layout,
    menuItems,
    metaInfo,
    onClick,
    renderAuthor,
    renderLabel,
    renderMenu,
    renderMetaInfo,
    services,
    title
  };
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const closeMenu = () => setIsMenuOpen(false);
  const [setMenuOutsideClickNode] = hooks_useClickOutside.useClickOutside({
    onClickOutside: closeMenu
  });
  let menuNode = null;
  const setMenuNode = (node) => {
    menuNode = node;
    setMenuOutsideClickNode(node);
  };
  const handleClick = (e) => {
    if (!menuNode || !menuNode.contains(e.target)) {
      onClick && onClick(e, computedState);
    }
  };
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [setExpansionOutsideClickNode] = hooks_useClickOutside.useClickOutside({
    onClickOutside: () => {
      if (canClickOutsideToClose) {
        setIsExpanded(false);
      }
    }
  });
  const { ref, width } = components_marketing_ZapCard_useResizeObserver.useResizeObserver();
  const uniqueServices = [
    ...new Set(services.map((service) => {
      return service.name;
    }))
  ];
  const computedState = Object.assign(Object.assign({
    isExpanded,
    isMenuOpen,
    layout
  }, getComputedColors(colorValue)), {
    width,
    uniqueServices
  });
  computedState.layout = layout !== "auto" ? layout : isCardLayoutWidth(computedState) ? "card" : "line";
  const canExpand = children && isLineLayout(computedState);
  const renderedMenu = renderMenu ? renderMenu(allProps, computedState, { closeMenu }) : defaultRenderMenu(allProps, computedState, { closeMenu });
  const renderedLabel = renderLabel ? renderLabel(allProps, computedState) : defaultRenderLabel(allProps, computedState);
  const renderedAuthor = renderAuthor ? renderAuthor(allProps, computedState) : defaultRenderAuthor(allProps, computedState);
  const renderedMetaInfo = renderMetaInfo ? renderMetaInfo(allProps, computedState) : defaultRenderMetaInfo(allProps, computedState);
  const DetailsLink = detailsLink && jsxRuntime.jsx("span", { className: styles.detailsHref, "data-zds": true, children: jsxRuntime.jsx(components_navigation_Link_Link.Link, { href: detailsLink.href, rel: detailsLink.rel, onClick: (e) => detailsLink === null || detailsLink === void 0 ? void 0 : detailsLink.onClick(e, computedState), children: "Details" }) });
  const link = shouldOverlayLink && (isCardLayout(computedState) || !children) && jsxRuntime.jsx(components_navigation_Link_Link.Link, { className: styles.link, href, target: hrefTarget, children: title });
  const details = canExpand && jsxRuntime.jsxs("details", { "data-testid": "ZapCard__details", open: isExpanded, "data-zds": true, children: [jsxRuntime.jsx("summary", { className: styles.summary, onClick: (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  }, "data-zds": true, children: "More details" }), jsxRuntime.jsx("div", { className: styles.detailsContent, "data-zds": true, children })] });
  const cta = isCardOrMegaLayout(computedState) ? jsxRuntime.jsx(ZapCardCTA, { computedState, ariaHidden: !!link, href, isLink: true, shouldOverlayLink, target: hrefTarget }) : isLineLayout(computedState) ? jsxRuntime.jsx(ZapCardCTA, { computedState, ariaHidden: !!link, href, isLink: false, shouldOverlayLink, target: hrefTarget }) : null;
  const serviceIconSize = isMegaLayout(computedState) ? "large" : "medium";
  const rootHasTopPadding = (isCardOrMegaLayout(computedState) || isLineLayout(computedState) && isMediumLineLayoutWidth(computedState)) && (hasMenu(allProps.menuItems) || allProps.authorName);
  return jsxRuntime.jsx("article", { className: styles.root, ref, "data-has-top-padding": rootHasTopPadding, "data-zds": true, children: jsxRuntime.jsxs("div", { className: styles.inner, "data-testid": "ZapCard__inner", "data-colored": shouldBeColored(computedState), "data-layout": getLayout(computedState), "data-expanded": computedState.isExpanded, style: {
    "--_zds-zapcard-background-color": computedState.backgroundColor,
    "--_zds-zapcard-background-color-dark": computedState.backgroundColorDark
  }, onClick: handleClick, ref: setExpansionOutsideClickNode, "data-zds": true, children: [jsxRuntime.jsxs("div", { className: styles.layout, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), style: computeLineLayoutGrid(computedState, allProps), "data-zds": true, children: [jsxRuntime.jsx("div", { className: styles.titleArea, "data-layout": getLayout(computedState), "data-zds": true, children: jsxRuntime.jsx(components_display_Heading_Heading.Heading, { className: styles.title, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), children: title }) }), renderedAuthor && jsxRuntime.jsx("div", { className: styles.authorArea, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), "data-zds": true, children: renderedAuthor }), jsxRuntime.jsxs("div", { className: styles.labelArea, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), "data-zds": true, children: [renderedLabel, DetailsLink] }), link, cta, jsxRuntime.jsxs("div", { className: styles.menuArea, ref: setMenuNode, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), "data-zds": true, children: [renderedMenu && jsxRuntime.jsx("button", { "aria-expanded": isMenuOpen, "aria-label": "More options", className: styles.menuToggle, onClick: () => setIsMenuOpen(!isMenuOpen), type: "button", "data-zds": true, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { name: "navMoreHoriz", size: 32 }) }), isMenuOpen && renderedMenu] }), jsxRuntime.jsx("div", { className: styles.servicesArea, "data-zds": true, children: jsxRuntime.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: uniqueServices.join(", "), position: "southwest", shouldCorrectPosition: false, tooltipId: "tooltip-zap-card", children: () => jsxRuntime.jsx(components_patterns_ServiceIcons_ServiceIcons.ServiceIcons, { "aria-label": `Zap uses ${uniqueServices.join(", ")}`, maxServices: 3, services, size: serviceIconSize, hasBorder: !shouldBeColored(computedState) }) }) }), jsxRuntime.jsx("div", { className: styles.metaInfoArea, "data-layout": getLayout(computedState), "data-width": getWidth(computedState), "data-zds": true, children: renderedMetaInfo })] }), details] }) });
};

exports.ZapCard = ZapCard;
//# sourceMappingURL=ZapCard.cjs.js.map
